import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { MiqAgColumn } from '../ag-table-grid-options';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'miq-ag-property-set-cell',
  template: ` <miq-property-sets-column [record]="data" [column]="colDef"></miq-property-sets-column> `,
  standalone: false,
})
export class AgPropertySetCellRendererComponent implements ICellRendererAngularComp {
  public data: Record<string, any>;
  public colDef: MiqAgColumn;

  agInit(params: ICellRendererParams): void {
    this.setValues(params);
  }

  refresh(params: ICellRendererParams) {
    this.setValues(params);
    return true;
  }

  private setValues(params: ICellRendererParams) {
    this.data = { ...(params.data ?? {}) };
    this.colDef = params.colDef ?? {};
    if (this.colDef.settings) {
      this.colDef.settings.value = params.getValue();
      this.colDef.settings.node = params.node;
    } else {
      this.colDef.settings = { value: params.getValue(), node: params.node };
    }
  }
}
